// extracted by mini-css-extract-plugin
export default {"btn_top":"GoToTop_btn_top__YiFLK","isvisible":"GoToTop_isvisible__ayqZ1","icon_top":"GoToTop_icon_top__hkXHt","gototop":"GoToTop_gototop__G2XsM"};